import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";

const InfoButton = ({ title, content }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Lihat definisi operasional">
        <IconButton
          size="small"
          onClick={handleOpen}
          style={{
            backgroundColor: "#1976d2",
            borderRadius: "4px",
            padding: "4px 8px",
            color: "#ffffff",
            transition: "background-color 0.3s",
            "&:hover": {
              backgroundColor: "#115293",
            },
          }}
        >
          <InfoIcon fontSize="small" style={{ color: "#ffffff" }} />
          <span
            style={{ marginLeft: "4px", fontSize: "14px", color: "#ffffff" }}
          >
            Definisi Operasional
          </span>
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Definisi Operasional</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ whiteSpace: "pre-line" }}>
            <span
              dangerouslySetInnerHTML={{
                __html:
                  content ||
                  "Tidak ada definisi operasional untuk pertanyaan ini.",
              }}
            ></span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tutup
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InfoButton;
